import { CommonGAssets } from '@hhgtech/hhg-components/gAssets'
import { IntlFormatters } from 'react-intl'

import { BMICondition, LOCALE } from 'interfaces/types'

export type HealthToolGender = 'male' | 'female' | ''

export enum HEALTH_TOOL_NAME {
  DUE_DATE = 'due-date-calculator',
  BMI = 'bmi',
  BMR = 'bmr',
  OVULATION = 'ovulation',
  IFRAME = 'IFRAME',
  PWG = 'pregnancy-weight-gain',
  THR = 'heart-rate',
  BABY_VACCINE = 'vaccination-tool',
  BABY_GROWTH = 'baby-growth-tracking',
  BABY_POOP = 'baby-poop-checking',
  AIR_POPULATION = 'air-population-tool',
}

export const HEALTH_TOOL_TYPE = {
  DUE_DATE: HEALTH_TOOL_NAME.DUE_DATE,
  BMI: HEALTH_TOOL_NAME.BMI,
  BMR: HEALTH_TOOL_NAME.BMR,
  OVULATION: HEALTH_TOOL_NAME.OVULATION,
  IFRAME: HEALTH_TOOL_NAME.IFRAME,
  PWG: HEALTH_TOOL_NAME.PWG,
  THR: HEALTH_TOOL_NAME.THR,
  BABY_VACCINE: HEALTH_TOOL_NAME.BABY_VACCINE,
  BABY_GROWTH: HEALTH_TOOL_NAME.BABY_GROWTH,
  BABY_POOP: HEALTH_TOOL_NAME.BABY_POOP,
}

export const HEALTH_TOOLS_VARIABLE: {
  [key in HEALTH_TOOL_NAME | string]?: {
    [key in LOCALE | string]?: string[]
  }
} = {
  [HEALTH_TOOL_NAME.BMI]: {
    // [LOCALE.Vietnam]: [
    //   'There are many factors that can affect your BMI, including:',
    //   'Age: Your BMR decreases as you get older',
    //   'Gender: Men typically have higher BMRs than women',
    //   'Weight: People with more muscle mass have higher BMRs than people with more fat mass',
    //   'Height: Taller people have higher BMRs than shorter people',
    //   'Body composition: People with more muscle mass have higher BMRs than people with more fat mass',
    //   'Activity level: People who are more active have higher BMRs than people who are less active',
    //   'Certain medical conditions: Some medical conditions, such as hyperthyroidism, can also lead to a high BMR.',
    // ],
  },
  [HEALTH_TOOL_NAME.BMR]: {
    // [LOCALE.Vietnam]: [
    //   'There are many factors that can affect your BMR, including:',
    //   'Age: Your BMR decreases as you get older',
    //   'Gender: Men typically have higher BMRs than women',
    //   'Weight: People with more muscle mass have higher BMRs than people with more fat mass',
    //   'Height: Taller people have higher BMRs than shorter people',
    //   'Body composition: People with more muscle mass have higher BMRs than people with more fat mass',
    //   'Activity level: People who are more active have higher BMRs than people who are less active',
    //   'Certain medical conditions: Some medical conditions, such as hyperthyroidism, can also lead to a high BMR.',
    // ],
  },
}

export type CaloriesResultApi = {
  bmi: {
    bmi: number
    minWeight: number
    maxWeight: number
    level: BMICondition
  }
  bmr: {
    bmr: number
    status: string
    suggestKcal: {
      kcalFrom: number
      kcalTo: number
      kgFrom: number
      kgTo: number
      target: string
    }
  }
}

export type CaloriesResult = {
  bmi: {
    bmi: number
    minWeight: number
    maxWeight: number
    level: BMICondition
  }
  bmr: {
    bmr: number
    status: string
    suggestKcal: {
      kcalFrom: number
      kcalTo: number
      kgFrom: number
      kgTo: number
      target: string
    }
  }
}

export enum ACTIVITY_LEVEL_NAME {
  LOW_INTENSITY = 'low_intensity',
  MODERATE_INTENSITY = 'moderate_intensity',
  AEROBIC_INTENSITY = 'aerobic_intensity',
  VIGOROUS_INTENSITY = 'vigorous_intensity',
  MAXIMUM_INTENSITY = 'maximum_intensity',
}

export const getActivityLevelShortLabel = (
  key: ACTIVITY_LEVEL_NAME,
  f: IntlFormatters['formatMessage'],
) => {
  const ACTIVITY_LEVEL_SHORT_LABEL_MAPPING: {
    [key in ACTIVITY_LEVEL_NAME]: string
  } = {
    [ACTIVITY_LEVEL_NAME.LOW_INTENSITY]: f({
      id: 'activityLevel.noExerciseShort',
    }),
    [ACTIVITY_LEVEL_NAME.MODERATE_INTENSITY]: f({
      id: 'activityLevel.oneThreeDaysShort',
    }),
    [ACTIVITY_LEVEL_NAME.AEROBIC_INTENSITY]: f({
      id: 'activityLevel.threeFiveDaysShort',
    }),
    [ACTIVITY_LEVEL_NAME.VIGOROUS_INTENSITY]: f({
      id: 'activityLevel.sixSevenDaysShort',
    }),
    [ACTIVITY_LEVEL_NAME.MAXIMUM_INTENSITY]: f({
      id: 'activityLevel.routineShort',
    }),
  }
  return ACTIVITY_LEVEL_SHORT_LABEL_MAPPING[key] || ''
}

export const getActivityLevelList = (f: IntlFormatters['formatMessage']) => [
  {
    label: f({
      id: 'activityLevel.noExercise',
      defaultMessage: 'Little to no exercise',
    }),
    value: ACTIVITY_LEVEL_NAME.LOW_INTENSITY,
    point: 1.2,
  },
  {
    label: f({
      id: 'activityLevel.oneThreeDays',
      defaultMessage: 'Light exercise 1–3 days a week',
    }),
    value: ACTIVITY_LEVEL_NAME.MODERATE_INTENSITY,
    point: 1.375,
  },
  {
    label: f({
      id: 'activityLevel.threeFiveDays',
      defaultMessage: 'Medium exercise 3–5 days a week',
    }),
    value: ACTIVITY_LEVEL_NAME.AEROBIC_INTENSITY,
    point: 1.55,
  },
  {
    label: f({
      id: 'activityLevel.sixSevenDays',
      defaultMessage: 'Hard exercise  6–7 days a week',
    }),
    value: ACTIVITY_LEVEL_NAME.VIGOROUS_INTENSITY,
    point: 1.725,
  },
  {
    label: f({
      id: 'activityLevel.routine',
      defaultMessage: 'Challenging exercise routine',
    }),
    value: ACTIVITY_LEVEL_NAME.MAXIMUM_INTENSITY,
    point: 1.9,
  },
]

export const HEALTH_TOOL_DEFAULT_IMG = {
  [HEALTH_TOOL_TYPE.DUE_DATE]: CommonGAssets.getAssetPath(
    'health-tools/due-date-icon.svg',
  ),
}

export const ADDITIONAL_QUESTION_PREFIX = 'additional_questions'
export const DEFAULT_BABY_NAME_VALUE = 'Noname'
